module.exports = __webpack_public_path__ + "img/pc_1.aadcc9df.png";